/*
 * @Author: bz2021 bz2021@mail.sdu.edu.cn
 * @Date: 2025-07-01 17:20:38
 * @LastEditors: bz2021 bz2021@mail.sdu.edu.cn
 * @LastEditTime: 2025-07-07 11:56:56
 * @FilePath: \a_span\frontend\management-app\src\api\auth.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '../utils/request';

// 登录请求
export const login = async (data) => {
  const formData = new URLSearchParams();
  for (const key in data) {
    formData.append(key, data[key]);
  }
  try {
    const response = await request({
      url: '/auth',
      method: 'post',
      data: formData,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token.token);
    }
    return response;
  } catch (error) {
    throw error;
  }
};

// 注册请求
export const register = (data) => {
  return request({
    url: '/register',
    method: 'post',
    data
  });
};

export const getUsers = (params) => {
  return request({ 
    url: '/users',
    method: 'post',
    data: params
  });
};

export const getUserlist = (data) => {
  return request({ 
    url: '/users_list',
    method: 'post',
    data: data
  });
};

export const getMyUserList = async (data) => {
  return await request({
    url: `/myusers`,
    method: 'post',
    data: data
  });
};

// 获取单个用户详情
export const getUser = async (userId) => {
  return await request({
    url: `/users/${userId}`,
    method: 'get'
  });
};

// 创建用户
export const createUser = async (userData) => {
  return await request({
    url: '/users/create',
    method: 'post',
    data: userData
  });
};

// 更新用户
export const updateUser = async (userId, userData) => {
  return await request({
    url: `/users/${userId}`,
    method: 'put',
    data: userData
  });
};